import { createFileRoute } from "@tanstack/react-router"

import PaymentPolicyPage from "@/features/static/components/payment-policy"

export const Route = createFileRoute("/_screen/payment-policy")({
  component: PaymentPolicy
})

function PaymentPolicy() {
  return <PaymentPolicyPage />
}
